import React from 'react';
import {
  Intro,
  Lead,
  Progression,
  Phase,
  Arrow,
  Closing,
  Emphasis,
  EmphasisLink,
  SupplementalLink,
} from './styles';

export const SUPPLEMENTAL_ANCHOR_ID = 'supplemental-training';

const scrollToSupplemental = (event) => {
  const target = document.getElementById(SUPPLEMENTAL_ANCHOR_ID);
  if (target) {
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const CurriculumIntro = ({ hasLibrary = false, elementsHref = null }) => (
  <Intro $hasLibrary={hasLibrary}>
    <Lead>
      The Praxis Curriculum is designed to progressively build your physical capability and skill
      over three main phases:
    </Lead>
    <Progression aria-label="Foundation, then Attributes, then Application">
      <Phase>Foundation</Phase>
      <Arrow aria-hidden="true">&rarr;</Arrow>
      <Phase>Attributes</Phase>
      <Arrow aria-hidden="true">&rarr;</Arrow>
      <Phase>Application</Phase>
    </Progression>
    <Closing>
      Start with{' '}
      {elementsHref ? (
        <EmphasisLink href={elementsHref}>Elements</EmphasisLink>
      ) : (
        <Emphasis>Elements</Emphasis>
      )}
      , then move to the next phase. Optionally, you can choose to add{' '}
      <SupplementalLink href={`#${SUPPLEMENTAL_ANCHOR_ID}`} onClick={scrollToSupplemental}>
        supplemental training
      </SupplementalLink>{' '}
      for your goals or to address specific needs.
    </Closing>
  </Intro>
);

export default CurriculumIntro;
